import React from "react";
import styled from "styled-components";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";

import * as colors from "../../../../assets/_base/colors";

const NotificationContainer = styled.div``;
const NotificationItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 3px;

  @media (max-width: 700px) {
    align-items: center;
    flex-direction: column;
    margin-bottom: 5px;
  }

  background-color: ${(props) => colors[props.type]};
`;
const NotificationLabel = styled(Text)`
  font-size: 1.4em;
  color: white !important;
  @media (max-width: 700px) {
    text-align: center;
  }
`;
const RoundedButton = styled(Button)`
  border-radius: 50px;
`;

export default (props) => {
  const [notifications, setNotifications] = React.useState([]);

  React.useEffect(() => {
    if (props.notifications) {
      setNotifications(props.notifications);
    }
  }, [props.notifications]);

  return (
    <NotificationContainer>
      {notifications.map((notification, idx) => {
        return (
          <NotificationItem
            key={`top-header-notification-${idx}`}
            type={notification.type}
          >
            <NotificationLabel>{notification.label}</NotificationLabel>
            <RoundedButton color="secondary" onClick={notification.buttonClick}>
              {notification.buttonLabel}
            </RoundedButton>
          </NotificationItem>
        );
      })}
    </NotificationContainer>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/TopHeaderNotifications/index.jsx